//  The maximum expected tractors
const MaxExpectedTractors = 3000;

//  The maximum expected tractor operators
const MaxExpectedOperators = 3000;

//  The maximum expected tractor farmers
const MaxExpectedFarmers = 200000;

//  The maximum expected FBO
const MaxExpectedFBO = 2500;

//  The maximum expected tractor requests
const MaxExpectedTractorRequests = 180000;

//  The maximum expected tractor owners
const MaxExpectedTractorOwners = 2500;

//  The maximum number of pending requests
const MaxPendingRequests = 1500;

export {
    MaxExpectedFarmers,
    MaxExpectedFBO,
    MaxExpectedOperators,
    MaxExpectedTractorOwners,
    MaxExpectedTractorRequests,
    MaxExpectedTractors,
    MaxPendingRequests,
}


// WEBPACK FOOTER //
// ./src/views/Dashboard/DashboardExpectations.js